const generatedBrowserVersionsForSentryLogging_rslib_entry_ = {
    and_chr: 133,
    android: 133,
    chrome: 79,
    edge: 124,
    firefox: 126,
    ios_saf: 16,
    opera: 105,
    safari: 16
};
export { generatedBrowserVersionsForSentryLogging_rslib_entry_ as default };

//# sourceMappingURL=generatedBrowserVersionsForSentryLogging.mjs.map